<template>
  <div :style="{paddingTop: userInfo ? '46px' : ''}">
    <router-view></router-view>

    <div class="mainFunc" v-if="userInfo">
      <van-tabbar v-model="active" @change="changeRoute">
        <van-tabbar-item  v-for="item in menuOptions" :key="item.id" :badge="item.name === 'alarmList' && alarmList.length ? alarmList.length : ''" :name="item.name">
          <template #icon="props">
            <i
              class="menu_iconfont"
              :class="'icon-' + item.id"
              :style="{color: active === item.id || props.active ? '#427BDA' : ''}"
            ></i>
          </template>
          {{item.label}}
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from 'moment'
import { mapState } from "vuex";
import longTouch from "@/utils/longTouch";
import { GetQueryString } from "@/utils/utils";

const menuOptions = [
  {
    id: "ditu",
    name: "mapData",
    label: "监测地图"
  },
  {
    id: "rank",
    name: "rank",
    label: "站点排名"
  },
  {
    id: "baojing",
    name: "alarmList",
    label: "报警列表"
  },
  {
    id: "limit",
    name: "explanation",
    label: "说明"
  },
  {
    id: "set",
    name: "set",
    label: "我的"
  }
];
export default {
  data() {
    return {
      menuId: "ditu",
      searchInfo: "",
      userListFiltered: [],
      group_name: "",
      addGroupShow: false,
      active: this.$route.name,
      alarmCount: 0
    };
  },
  watch: {},
  computed: {
    scHeight: function() {
      return "" + document.documentElement.clientHeight - 138;
    },
    ...mapState(["userInfo", "userGroups", "userList", "alarmList", "hideBackBtn"]),
    menuOptions() {
      let hideSetTabbar = GetQueryString('hideSetTabbar')
      let menuList = menuOptions
      if (!!hideSetTabbar) {
        menuList = menuList.filter(x => x.name != 'set')
      }
      // 起步区水质微站隐藏报警列表
      let host = GetQueryString("host") || location.host;
      if (host == "jnwater.novaecs.com") {
        menuList = menuList.filter(x => x.name != 'alarmList')
      }
      return menuList
    }
  },
  mounted() {
    console.log("mounted")
    this.$router.afterEach((to, from) => {
      if (to.meta.index) {
        this.active = to.name
      }
    })
  },
  methods: {
    changeRoute(v) {
      console.log(v)
      // this.active = v
      if (!this.hideBackBtn) {
        this.$router.push({ name: v });
      } else {
        this.$router.replace({ name: v });
      }
    },
    gotoPage(target) {
      this.menuId = target.id;
      this.$router.push({ name: target.name });
    },
    getAlarmList() {
      var end_t = moment().format("YYYY-MM-DD HH:mm:ss");
      var start_t = moment()
        .subtract(3, "days")
        .format("YYYY-MM-DD HH:mm:ss");
      this.$store.dispatch("getAlarmList", {start_t, end_t})
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 46px;
}
.func_cell {
  width: 20%;
  /* margin-bottom: 20px */
}
.func_img {
  width: 45px;
}
.func_font {
  font-size: 14px;
  color: #151515;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/mainFunc.vue